import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.InteracBulkPayoutResponse,
  BulkPayout: (params: vp.InteracBulkPayoutRequest) => void,
  reset: () => void,
  BulkPayoutAync: (params: vp.InteracBulkPayoutRequest) => Promise<vp.InteracBulkPayoutResponse>,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostBulkPayoutRequest: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldBulkPayout, setShouldBulkPayout] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.InteracBulkPayoutRequest>({
    PortalUser: '',
    Amount: 0,
    Currency: '',
    RecipientName: '',
    MessageForRecipient: '',
    ClientReferenceNumber: '',
    Notes: '',
    ClientAccountID: '',
    Language: '',
    Question: '',
    Answer: '',
    Memo: '',
  });

  const [response, setResponse] = useState<vp.InteracBulkPayoutResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
    Flagged: '',
    TransactionStatus: '',
  });

  useEffect(() => {
    if (!shouldBulkPayout) return () => {};

    const PostBulkPayout = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postBulkPayoutRequest(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldBulkPayout) void PostBulkPayout();
    setShouldBulkPayout(false);
    return () => {
      source.cancel();
    };
  }, [shouldBulkPayout]);

  return [
    response,
    (_params: vp.InteracBulkPayoutRequest) => {
      setParams(_params);
      setShouldBulkPayout(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
        Flagged: '',
        TransactionStatus: '',
      });
      setShouldBulkPayout(false);
    },
    async (params: vp.InteracBulkPayoutRequest) => {
      return api.postBulkPayoutRequest(params, source);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostBulkPayoutRequest);
